import { xhr } from "$app/utils"

export async function update(task: any, data: any): Promise<any> {
  const url = `/plans/${task.plan_id}/tasks/${task.id}.json`

  return await xhr.patch(url, { task: data })
}

export async function post(plan_id: number, data: any): Promise<any> {
  const url = `/plans/${plan_id}/tasks.json`

  return await xhr.post(url, { task: data })
}

export async function destroy(task: any): Promise<any> {
  const url = `/plans/${task.plan_id}/tasks/${task.id}.json`

  return await xhr.delete(url)
}
